import { BaseCamera } from './camera';
import { LocationFilterValue } from './common';
import { PartialLocation } from './location';

export interface AudioDevice {
  proxyUrl: string;
  clientAudioDeviceId: string;
  automatedTalkdownGapSec: number;
  id: number;
  location: PartialLocation;
  deviceType: AudioDeviceType;
  url: string;
  userName?: string;
  passwordFilePath?: string;
  passwordAudio?: string;
  tenantId?: string;
  enableAutomatedTalkdown: boolean;
  isSPSEnabled?: boolean;
  isEnabled?: boolean;
  cameras: BaseCamera[];
}
type AudioDeviceType = (typeof audioDeviceTypes)[number];
export const audioDeviceTypes = [
  'AXIS',
  'ACS',
  'ONVIF',
  'AXIS_SIREN',
  'SIP',
  'EAGLE_EYE',
  'VDS',
  'GO2RTC_ONVIF',
  'UNV',
  'TOA',
  'HAKIMO_ONVIF',
];
export interface AudioDevicesDTO {
  items: AudioDevice[];
  total: number;
}

export type AddAudioDevicePayload = Partial<AudioDevice>[];
export interface ModifyAudioDeviceCamMappingPayload {
  audioDeviceId: number;
  cameraId: string;
}

export interface AudioFilterValues {
  location: LocationFilterValue;
}
